import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { Button } from 'app/src/elements/buttons';
import ExternalLink from 'app/src/elements/ExternalLink';
import { Text } from 'app/src/styles';

import { phoneNumber } from 'app/src/utils/formatting';

const Container = styled(View)`
  max-width: 400px;
  padding-right: 10px;
  margin-right: 10px;
  border-right-width: 1px;
  border-right-color: #000000;
  border-right-style: solid;
`;

const Address = ({ address }) => {
  return (
    <View style={{ marginTop: 5 }}>
      <Text>
        {address.street}, {address.city}, {address.state} {address.zip}
      </Text>
    </View>
  );
};

const Customer = ({ customer }) => {
  return (
    <Container>
      <ExternalLink url={customer.url}>
        <Text style={{ fontWeight: 600 }}>{customer.fullName}</Text>
      </ExternalLink>

      <Text style={{ marginBottom: 6 }}>
        Number of Orders: {customer.ordersCount}
      </Text>

      <Text>{phoneNumber(customer.phone)}</Text>
      <Text>{customer.email}</Text>

      {customer.addresses.map(address => (
        <Address key={address.id} address={address} />
      ))}

      <Button label="Ignore" />
    </Container>
  );
};

export default Customer;
